export default __webpack_public_path__ + "static/Noel_Jett-2b0e48cbfac7ceb32d4d14ade209bdf3.jpg";